<template>
  <div>
    <div class="card">
      <div class="card-header"><h4>Visualizar Pedido</h4></div>
      <div class="card-body">
        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            aria-labelledby="pills-home-tab"
          >
            <div class="row">
              <div class="col-md-3">
                <label for="nome">Nome</label>
                <input
                  id="nome"
                  type="text"
                  class="form-control"
                  v-model="state.pedido.nome"
                />
              </div>
              <div class="col-md-3">
                <label for="tipo">Tipo</label>
                <input
                  id="tipo"
                  type="text"
                  class="form-control"
                  v-model="state.pedido.tipo"
                  readonly
                />
              </div>
              <div class="col-md-3">
                <label for="rg">RG</label>
                <input
                  id="rg"
                  type="text"
                  class="form-control"
                  placeholder="Digite um rg:"
                  v-mask="'00.000.000-0'"
                  v-model="state.pedido.rg"
                  readonly
                />
              </div>
              <div class="col-md-3">
                <label for="cpf">CPF</label>
                <input
                  id="cpf"
                  type="text"
                  class="form-control"
                  placeholder="Digite um cpf:"
                  v-mask-cpf
                  v-model="state.pedido.cpf"
                  readonly
                />
              </div>
              <div class="col-md-3">
                <label for="pai">Nome do Pai</label>
                <input
                  id="pai"
                  type="text"
                  class="form-control"
                  placeholder="Digite um nome:"
                  v-model="state.pedido.nome_pai"
                />
              </div>
              <div class="col-md-3">
                <label for="mae">Nome do Mãe</label>
                <input
                  id="mae"
                  type="text"
                  class="form-control"
                  placeholder="Digite um nome:"
                  v-model="state.pedido.nome_mae"
                />
              </div>
              <div class="col-md-3">
                <label for="telefone">Telefone</label>
                <input
                  id="telefone"
                  type="text"
                  class="form-control"
                  placeholder="Digite um telefone:"
                  v-mask-phone.br
                  v-model="state.pedido.telefone"
                />
              </div>
              <div class="col-md-3">
                <label for="email">Email</label>
                <input
                  id="email"
                  type="email"
                  class="form-control"
                  placeholder="Digite um email:"
                  v-model="state.pedido.email"
                />
              </div>
              <div class="col-md-3">
                <label>Status</label>
                <select class="form-select" v-model="state.pedido.status">
                  <option value="PENDENTE">Pendente</option>
                  <option value="EM_ANDAMENTO">Em Andameto</option>
                  <option value="ENVIADO">Enviado</option>
                  <option value="CANCELADO">Cancelado</option>
                </select>
              </div>
              <div
                class="col-md-3"
                v-if="
                  state.tipo_foto == 'jpg' ||
                  state.tipo_foto == 'png' ||
                  state.tipo_foto == 'jpeg'
                "
              >
                <label>Foto</label>
                <div style="text-align: left">
                  <a target="_blank" :href="state.arquivos.foto">
                    <img class="icon" src="../../../public/img/image.png"
                  /></a>
                </div>
              </div>
              <div class="col-md-3" v-else>
                <label>Foto</label>
                <div style="text-align: left">
                  <a target="_blank" :href="state.arquivos.foto">
                    <img class="icon" src="../../../public/img/pdf-icon.png"
                  /></a>
                </div>
              </div>
              <div
                class="col-md-3"
                v-if="
                  state.tipo_laudo == 'jpg' ||
                  state.tipo_laudo == 'png' ||
                  state.tipo_laudo == 'jpeg'
                "
              >
                <label>Laudo</label>
                <div style="text-align: left">
                  <a target="_blank" :href="state.arquivos.laudo_autismo">
                    <img class="icon" src="../../../public/img/image.png"
                  /></a>
                </div>
              </div>
              <div class="col-md-3" v-else>
                <label>Laudo</label>
                <div style="text-align: left">
                  <a target="_blank" :href="state.arquivos.laudo_autismo">
                    <img class="icon" src="../../../public/img/pdf-icon.png"
                  /></a>
                </div>
              </div>
              <div
                class="col-md-3"
                v-if="
                  state.tipo_certidao == 'jpg' ||
                  state.tipo_certidao == 'png' ||
                  state.tipo_certidao == 'jpeg'
                "
              >
                <label>Certidão de Nascimento</label>
                <div style="text-align: left">
                  <a target="_blank" :href="state.arquivos.certidao_nascimento">
                    <img class="icon" src="../../../public/img/image.png"
                  /></a>
                </div>
              </div>
              <div class="col-md-3" v-else>
                <label>Certidão de Nascimento</label>
                <div style="text-align: left">
                  <a target="_blank" :href="state.arquivos.certidao_nascimento">
                    <img class="icon" src="../../../public/img/pdf-icon.png"
                  /></a>
                </div>
              </div>
              <div
                class="col-md-3"
                v-if="
                  state.tipo_comprovante == 'jpg' ||
                  state.tipo_comprovante == 'png' ||
                  state.tipo_comprovante == 'jpeg'
                "
              >
                <label>Comprovante de Resiência</label>
                <div style="text-align: left">
                  <a
                    target="_blank"
                    :href="state.arquivos.comprovante_residencia"
                  >
                    <img class="icon" src="../../../public/img/image.png"
                  /></a>
                </div>
              </div>
              <div class="col-md-3" v-else>
                <label>Comprovante de Resiência</label>
                <div style="text-align: left">
                  <a
                    target="_blank"
                    :href="state.arquivos.comprovante_residencia"
                  >
                    <img class="icon" src="../../../public/img/pdf-icon.png"
                  /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btns_right">
          <button @click="salvarPedido" type="button" class="btn_save">
            Salvar
          </button>
          <router-link to="/pedidos-cartao">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      pedido: {
        id: "",
        nome: "",
        nome_pai: "",
        nome_mae: "",
        telefone: "",
        tipo: "",
        email: "",
        status: "",
      },
      arquivos: {},
    });
    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetchPedido();
      }
    });
    async function fetchPedido() {
      try {
        const { data } = await services.pedidos_cartao.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.pedido = data;
        state.arquivos = data.arquivos;
        state.tipo_foto = data.arquivos.foto.split(".", "5")[
          data.arquivos.foto.split(".", "5").length - 1
        ];
        state.tipo_laudo = data.arquivos.laudo_autismo.split(".", "5")[
          data.arquivos.laudo_autismo.split(".", "5").length - 1
        ];
        state.tipo_comprovante = data.arquivos.comprovante_residencia.split(
          ".",
          "5"
        )[data.arquivos.comprovante_residencia.split(".", "5").length - 1];
        state.tipo_certidao = data.arquivos.certidao_nascimento.split(".", "5")[
          data.arquivos.certidao_nascimento.split(".", "5").length - 1
        ];
      } catch (error) {
        console.log(error);
      }
    }
    //   let array = ["oi", "eae", "hi", "hello"];
    //   let newArray = array.splice(0, 1);
    //   console.log(newArray);
    async function salvarPedido() {
      try {
        var value = state.pedido.telefone;
        var clean = value.replace(/[^0-9,]*/g, "");
        state.pedido.telefone = clean;
        await services.pedidos_cartao.update(state.pedido, token);
        router.push({ name: "PedidosCartao" });
      } catch (error) {
        console.log(error);
      }
    }
    return {
      salvarPedido,
      router,
      state,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}
label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}
input {
  border: solid 1px #000;
}
input:focus {
  border: solid 1px #47b0a9;
}
select {
  border: solid 1px #000;
}
select:focus {
  border: solid 1px #47b0a9;
}
.btns_right {
  text-align: right;
  margin-top: 1rem;
}
.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_save:hover {
  background: #008000;
}
.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: #8f0303;
}
.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
textarea {
  resize: none;
  border: solid 1px #000;
}
textarea:focus {
  border: solid 1px #47b0a9;
}
#pills-home-tab {
  color: #000;
}
#pills-home-tab:focus {
  color: #47b0a9;
}
#pills-profile-tab {
  color: #000000;
}
#pills-profile-tab:focus {
  color: #47b0a9;
}
.imagem {
  width: 100%;
  height: auto;
  -o-object-fit: cover;
  object-fit: cover;
  margin-top: 2rem;
  border: solid 2px #4bafa9;
}
.btn_deletar_imagem {
  margin-left: 10px;
  height: 30px;
  width: 30px;
  margin-top: 2rem;
  background: #c4342d;
  color: #000;
  border: solid 1px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_deletar_imagem:hover {
  background: #8f0303;
  border: solid 1px #000;
}
.icon {
  width: 100px;
  height: 100px;
  margin-top: 1rem;
}
</style>